import React, { lazy }  from 'react'

import {Route} from "react-router-dom"

import {TabBar, Popup, Form, Input, Space, Button, Switch} from "antd-mobile"

import styles from '../../../assets/css/wap/layout/default.module.scss'

import {API, isLeader, isSuper, removeStorage} from "../../../utils"

import {message} from "antd"

// 导入路由
const Client = lazy(() => import('../Client'))
const Highseas = lazy(() => import('../Client/highseas'))
const User = lazy(() => import('../User'))

export default class Default extends React.PureComponent {
    state = {
        // 指定当前默认选中的菜单项，this.props.location.pathname：获取当前的路由地址
        defaultActiveKey: this.props.location.pathname,
        tabs: [],
        userOpen: false,
        userInfo: {}
    }

    userDrawerFormRes = React.createRef()

    renderUser = () => {
        let { userOpen, userInfo } = this.state
        let nickname = ''
        if (isLeader() && userInfo.team.property === 2) {
            nickname += "余额：" + userInfo.team.money + "，预估余额："+userInfo.team.predict_money
        }

        return (
            <Popup visible={ userOpen } onMaskClick={ () => {this.setState({userOpen: false, defaultActiveKey: null})} } bodyStyle={{ borderTopLeftRadius: '8px', borderTopRightRadius: '8px', padding: '12px'}}>
                <div style={{ overflowY: 'scroll', height: '100%' }}>
                    <Space justify='between' align='center' style={{ borderBottom: '1px solid #d1d4e5', position: 'fixed', height: '55px', zIndex: 2, left: 0, top: 0, padding: '0 12px', background: '#fff', width: '100%'}}>
                        <span>{ nickname }</span>
                        <Switch defaultChecked={userInfo.in_three === 1} checkedText="接收数据" uncheckedText="关闭数据" onChange={async () => {
                            await API.get('/user/dataaccep', {
                                params: {
                                    'field': 'in_three',
                                    'value': (userInfo.in_three === 1 ? 0 : 1)
                                }
                            })
                            window.location.reload()
                        }} style={{
                            '--checked-color': '#00b578',
                            '--height': '20px',
                            '--width': '40px',
                        }} />
                    </Space>

                    <Form ref={ this.userDrawerFormRes } layout='horizontal' style={{ marginTop: '40px' }} onFinish={async (values) => {
                        try {
                            await API.post('/user/changepwd', values)

                            removeStorage('right_menu')
                            removeStorage('power')
                            removeStorage('left_menu')
                            removeStorage('limit')
                            removeStorage('user')

                            this.props.history.replace('/login')
                        } catch (e) {}
                    }}>
                        <Form.Item name='oldpassword' label='旧密码：' rules={[{ required: true, message: '请输入旧密码!' }]}>
                            <Input type="password" />
                        </Form.Item>

                        <Form.Item name='newpassword' label='新密码：' rules={[{ required: true, message: '请输入新密码!' }]}>
                            <Input type="password" />
                        </Form.Item>

                        <Form.Item name='renewpassword' label='确认新密码：' rules={[{ required: true, message: '请确认新密码!' }]}>
                            <Input type="password" />
                        </Form.Item>

                        <Space>
                        <Button color='primary' size='small' onClick={ () => { this.userDrawerFormRes.current.submit() } }>修改密码</Button>

                        <Button color='primary' size='small' onClick={ () => {
                            message.success('正在退出', 1, () => {
                                removeStorage('right_menu')
                                removeStorage('power')
                                removeStorage('left_menu')
                                removeStorage('limit')
                                removeStorage('user')

                                this.props.history.replace('/login')

                            })
                        } }>退出登录</Button>
                        </Space>
                    </Form>
                </div>
            </Popup>
        )
    }

    render() {
        let { tabs, defaultActiveKey, userOpen } = this.state

        console.info(tabs)
        return (
            <div className={ styles.layout }>

                <Route exact path="/home/client" component={ Client } />
                <Route exact path="/home/clientHighseas" component={ Highseas } />
                <Route exact path="/home/userList" component={ User } />

                <TabBar className={ styles.layout_tabs } onChange={ async (value) => {
                    if (value !== 'my') {
                        this.props.history.push(value)
                    } else {
                        let userInfo = await API.get('/user/userinfo')
                        this.setState({
                            userInfo
                        }, () => {
                            this.setState({
                                userOpen: true
                            })
                        })
                    }
                }} defaultActiveKey={ defaultActiveKey } activeKey={ defaultActiveKey }>
                    {tabs.map(item => (
                        <TabBar.Item key={item.key} title={item.title} icon={<i style={{fontSize: '25px'}} className={`crm-iconfont ${item.icon}`} />} badge={item.badge} />
                    ))}
                </TabBar>


                { userOpen ? this.renderUser() : <></> }
            </div>
        )
    }

    componentDidMount() {
        let tabs = []
        if (isSuper() || isLeader()) {
            tabs = [
                /*{ key: '/home/board', title: '看板', icon: 'crm-icon-shujukanban' },*/
                { key: '/home/userList', title: '成员', icon: 'crm-icon-shujukanban' },
                /*{ key: 'backlog', title: '待办中心', icon: 'crm-icon-daibanshixiang', badge: '5' },*/
                { key: '/home/client', title: '客户', icon: 'crm-icon-kehu' },
                /*{ key: 'tool', title: '工具', icon: 'crm-icon-yingyong' },*/
                { key: 'my', title: '我的', icon: 'crm-icon-wode1' },
            ]
        } else {
            tabs = [
                /*{ key: '/home/board', title: '看板', icon: 'crm-icon-shujukanban' },*/
                /*{ key: 'backlog', title: '待办中心', icon: 'crm-icon-daibanshixiang', badge: '5' },*/
                { key: '/home/client', title: '客户', icon: 'crm-icon-kehu' },
                /*{ key: 'tool', title: '工具', icon: 'crm-icon-yingyong' },*/
                { key: 'my', title: '我的', icon: 'crm-icon-wode1' },
            ]
        }

        this.setState({
            tabs
        })
    }

    /**
     * 生命周期函数
     * 触发时间：组件更新（完成 DOM 渲染）之后
     * 使用场景
     *  1、发送网络请求
     *  2、DMO 操作
     *  3、如果要用 setState()，必须要放在 if 条件中
     *
     * @param prevProps 上一次的 prevProps
     * @param prevState 上一次的 prevState
     * @param snapshot
     */
    componentDidUpdate(prevProps, prevState, snapshot) {
        this.setState({
            defaultActiveKey: this.props.location.pathname
        })
    }
}